var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWeatherSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.074 11.855a6.222 6.222 0 11-12.443-.003 6.222 6.222 0 0112.443.003zM11.853 2v1.557V2zm0 18.15v1.557-1.557zM4.886 4.886l1.101 1.1-1.1-1.1zM17.72 17.721l1.1 1.1-1.1-1.1zM2 11.855l1.557-.001L2 11.855zm18.15 0h1.557-1.557zM4.887 18.82l1.1-1.101-1.1 1.102zM17.721 5.987l1.101-1.101-1.1 1.1z",
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })));
}

export default SvgIconWeatherSun;